import template from './branch_funding_source.html';
import controller from './branch_funding_source.controller';
import './branch_funding_source.scss';

let branchFundingSourceComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default branchFundingSourceComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/branch_funding_source.component.js